/* eslint-disable prettier/prettier */
import axios from 'axios';
import { BASE_API, USER_TOKEN } from 'config/consts';
import { getDefaultStationId, resolveStationIds } from '../helpers/clubsMultiStation';
import { LINK_PAGAMENTO_TYPE_ID } from './types';

const getToken = () => JSON.parse(localStorage.getItem(USER_TOKEN));

const resolveStationIdList = (values, auth) => {
  const defaultStationId = getDefaultStationId(auth);
  const fromResolve = resolveStationIds(values, defaultStationId);
  if (fromResolve.length > 0) return fromResolve;

  const raw = values?.stations_field || [];
  const fromField = raw
    .map((item) => (typeof item === 'object' ? item.id || item.value : item))
    .filter(Boolean);
  if (fromField.length > 0) return [...new Set(fromField)];
  return defaultStationId ? [defaultStationId] : [];
};

export const upsertLinkPagamentoActivity = async (values, auth) => {
  const stations = resolveStationIdList(values, auth);
  const primaryStationId = getDefaultStationId(auth) || stations[0];
  const name = values.body_name || values.service_name || values.name || 'Link de Pagamento';
  const description =
    values.body_description ||
    values.description ||
    values.custom_message ||
    'Atividade de link de pagamento';

  const body = {
    name,
    description,
    stations_field: (values.stations_field || stations).map((item) =>
      typeof item === 'object' ? item : { id: item }
    ),
    categories_field: (values.categories_field || []).map((item) =>
      typeof item === 'object' ? item : { id: item }
    ),
    payment_methods: values.payment_methods || ['pix', 'credit_card', 'boleto'],
    payment_option: values.payment_option || 'payment_only',
    recurrence_type: values.recurrence_type || 'single',
    allow_installments: values.allow_installments || false,
    has_partner: values.has_partner || false,
    partners_split: values.partners_split || [],
    link_value: parseFloat(values.link_value) || 0,
    station_percentage: values.station_percentage,
    partner_percentage: values.partner_percentage,
    partner_recipient_id: values.partner_recipient_id || null,
    partner_user_id: values.partner_user_id || null,
    partner_name: values.partner_name || null,
    custom_message: values.custom_message || '',
    send_email: values.send_email !== false,
    send_whatsapp: values.send_whatsapp !== false,
    is_link_pagamento: true,
  };

  const payload = {
    name,
    description,
    summary: values.body_summary || values.summary || name,
    categories: (values.categories_field || []).map((item) => item.id || item).filter(Boolean),
    stations,
    parent_station_id: primaryStationId,
    image: values.image || null,
    body,
    payment_methods: body.payment_methods,
    payment_option: body.payment_option,
    recurrence_type: body.recurrence_type,
    allow_installments: body.allow_installments,
    has_partner: body.has_partner,
    partners_split: body.partners_split,
    link_value: body.link_value,
    station_percentage: body.station_percentage,
    partner_percentage: body.partner_percentage,
    partner_recipient_id: body.partner_recipient_id,
    partner_user_id: body.partner_user_id,
    partner_name: body.partner_name,
    custom_message: body.custom_message,
    send_email: body.send_email,
    send_whatsapp: body.send_whatsapp,
    start: values.start,
    end: values.end,
    participationStart: values.participationStart,
    participationEnd: values.participationEnd,
    click_me_label: values.click_me_label || 'Pagar',
    type_id: LINK_PAGAMENTO_TYPE_ID,
  };

  const headers = { Authorization: `${getToken()}` };
  if (values.id) {
    const response = await axios.put(
      `${BASE_API}/link-pagamento/update/${values.id}`,
      payload,
      { headers }
    );
    return {
      id: values.id,
      parent_action_id:
        response.data?.data?.id || response.data?.data?.parent_action_id || values.id,
    };
  }

  const response = await axios.post(`${BASE_API}/link-pagamento/publish`, payload, { headers });
  return {
    id: response.data?.data?.parent_action_id,
    parent_action_id: response.data?.data?.parent_action_id,
    created_actions: response.data?.data?.created_actions || [],
  };
};
